import { useMe, type AuthAction } from '@/context/MeProvider'

/** Preemptive notice when a signed-in user cannot call a gated API yet. */
export function AuthNotice({ action }: { action: AuthAction }) {
  const { messageFor } = useMe()
  const message = messageFor(action)
  if (!message) {
    return null
  }
  return (
    <p className="font-body text-body-sm text-fg-muted" role="status">
      {message}
    </p>
  )
}
